const newEventsPresenter = require('./resultPresenter/eventsPresenter');
const newPackageEventsPresenter = require('./resultPresenter/packageEventsPresenter');
const newSignaturesPresenter = require('./resultPresenter/signaturesPresenter');
const newOrderInformationPresenter = require('./resultPresenter/orderInformationPresenter');
const newDocumentsPresenter = require('./resultPresenter/documentsPresenter');
const newPackagesPresenter = require('./resultPresenter/packagesPresenter');
const { setViewData } = require('gui');

module.exports = function resultPresenter(resultDto) {
    const view = require('./resultPresenter.tpl.html');
    const eventsPresenter = newEventsPresenter(resultDto.events);
    const packageEventsPresenter = newPackageEventsPresenter(resultDto.packageEvents);
    const signaturesPresenter = newSignaturesPresenter(resultDto);
    const orderInformationPresenter = newOrderInformationPresenter(resultDto);
    const documentsPresenter = newDocumentsPresenter(resultDto.documents);
    const packagesPresenter = newPackagesPresenter(resultDto.packages, resultDto.packageEvents);
    var c = {};

    c.activate = function(region) {
        view.activate(region);
        setViewData(view, resultDto);

        eventsPresenter.activate(view.eventsRegion);
        packageEventsPresenter.activate(view.packageEventsRegion);
        signaturesPresenter.activate(view.signaturesRegion);
        orderInformationPresenter.activate(view.informationRegion);
        documentsPresenter.activate(view.documentsRegion);
        packagesPresenter.activate(view.packagesRegion);
    };

    c.deactivate = function() {
        packagesPresenter.deactivate();
        documentsPresenter.deactivate();
        orderInformationPresenter.deactivate();
        packageEventsPresenter.deactivate();
        eventsPresenter.deactivate();
        view.deactivate();
    };

    return c;
};
